"use client";
import React from "react";
import {
  findPropertyById,
  mockProperties,
} from "../../constants/mockProperties";
import { members } from "./components";
import { useParams } from "next/navigation";
import DynamicSlider from "./components/DynamicSlider";
import ContactMandate from "./components/ContactMandate";
import { TeamCardWhatsapp } from "./components/TeamCard";
import SimilarProperties from "./components/SimilarProperties";
import { BranchSummaryCard } from "./Branches";
import PropertyUtilities from "../../constants/utilitiesIcons";
// import { ProfileSummary } from "../../constants/branchData";
import { LocationIcon } from "./PropertyPage1";
import { utilities } from "./PropertyPage1";
import Accordion from "./components/Accordion";
import { PriceCard } from "./PropertyPage1";
import { ParentCard } from "./PropertyPage1";
import Example from "./components/Map";
import { PropertyInfo } from "./RentPage1";
import { ShowMoreText } from "./About1";
import { mockDesc } from "../design2/Sale2";

// const priceData: ProfileSummary = {
//   title: "Price & Other Charges",
//   values: {
//     "Property Price": "₦3,300,300",
//     "Agency Fee": "₦3,300,300",
//     "Inspection Fee": "₦3,300,300",
//     "Other Fee": "₦3,300,300",
//   },
// };

// outright sales
const firstDepositData = {
  title: "First Deposit",
  values: {
    "6 Months Plan": "₦3,300,300",
    "12 Months Plan": "₦3,300,300",
    "24 Months Plan": "₦3,300,300",
    "48 Months Plan": "₦3,300,300",
  },
};
const monthlySpreadingData = {
  title: "Monthly Spreading",
  values: {
    "6 Months Plan": "₦3,300,300",
    "12 Months Plan": "₦3,300,300",
    "24 Months Plan": "₦3,300,300",
    "48 Months Plan": "₦3,300,300",
  },
};
export function camelCaseToWords(camelCaseStr: string): string {
  return camelCaseStr
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}

const PropertyPage1 = () => {
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const property = findPropertyById(toNum)!;

  const isOutRight = !property.beforePrice;

  const otherChargesData = {
    title: isOutRight ? "Price & Other Charges" : "Other Charges", // ✅ Correct syntax
    values: {
      Documents: "₦3,300,300",
      "Survey Fee": "₦3,300,300",
      "Development Fee": "₦3,300,300",
      "Other Fee": "₦3,300,300",
    },
  };

  return (
    <section className="py-10 w-full overflow-clip">
      <div className="wrapper">
        <div className="grid-container relative">
          <div className="item flex flex-col gap-10">
            <div className="carousel w-auto">
              <DynamicSlider
                url="hello"
                slides={[...mockProperties["forRent"][0].images]}
              />
            </div>
            <div className="carousel my-4">
              <div className="first flex items-center justify-between">
                <h3 className="font-semibold">
                  {mockProperties.forRent[0].title}
                </h3>
                <span className="text-label-main">
                  Property ID: {mockProperties.forRent[0].id}
                </span>
              </div>
              <div className="first flex items-center justify-between">
                <h5 className="text-label flex gap-1">
                  <LocationIcon />
                  {mockProperties.forRent[0].address}
                </h5>
                <span className="text-themeColor capitalize">
                  {mockProperties.forRent[0].category}
                </span>
              </div>
            </div>
            <ParentCard header="Property Brief">
              <ShowMoreText text={mockDesc} />
            </ParentCard>
            <ParentCard header="Facilities">
              <PropertyUtilities selectedItems={utilities} />
            </ParentCard>
            <PropertyInfo
              details={!isOutRight ? propertyDetails : propertyDetailsAlt}
              title="Property Information"
            />

            {!isOutRight && (
              <Accordion
                data={{
                  title: "Terms & Conditions",
                  questions: [
                    {
                      question: "Refund Policy",
                      answer: "You can request a refund within 7 days.",
                    },
                    {
                      question: "Property Facility",
                      answer: "Facilities include WiFi, Pool, and Gym.",
                    },
                    {
                      question: "Other Rules",
                      answer: "No smoking inside the premises.",
                    },
                  ],
                }}
              />
            )}

            {!isOutRight && <BranchSummaryCard variant {...firstDepositData} />}
            {!isOutRight && (
              <BranchSummaryCard variant {...monthlySpreadingData} />
            )}
            <BranchSummaryCard variant {...otherChargesData} />
            <ParentCard header="Location">
              {/* lat={6.4913408} lng={3.391488} */}
              <Example coordinates={[6.4913408, 3.391488]} />
            </ParentCard>
            <ParentCard header="Document">
              <p className="mb-4">C of O. Record Copy Survey, Agreement</p>
              <div className="carousel w-auto">
                <DynamicSlider variant slides={planImage} />
              </div>
            </ParentCard>
            <ParentCard header="Buiding Plan">
              <div className="carousel w-auto">
                <DynamicSlider variant slides={planImage} />
              </div>
            </ParentCard>
          </div>
          <div id="child" className="w-full flex flex-col gap-14">
            <PriceCard {...findPropertyById(toNum)} />
            <div className="card mt-24">
              <TeamCardWhatsapp {...members[0]} />
            </div>
            <ContactMandate email={members[0].email} />
          </div>
        </div>
        <SimilarProperties
          arr={[...mockProperties["forSale"], ...mockProperties["forSale"]]}
        />
      </div>
    </section>
  );
};
export default PropertyPage1;
type PropertyItem = { key: string; value: string };
type PropertyData = { pair?: PropertyItem[]; key?: string; value?: string };
// interface PropertyInfoProps {
//   details: PropertyData[];
//   title: string;
// }

// const propertyDetails: PropertyData[] = [
//   { key: "Property Title", value: "Obolongo Estate" },
//   { key: "Category", value: "Residential" },
//   { key: "Preference", value: "Newly Built" },
//   { key: "Unit Type", value: "Block Of Flat" },
//   { key: "Unit Sub Type", value: "Block" },
//   { key: "Total Area", value: "4354sqm" },
//   {
//     pair: [
//       { key: "Bathroom", value: "21" },
//       { key: "Bedroom", value: "21" },
//     ],
//   },
//   {
//     pair: [
//       { key: "Toilet", value: "21" },
//       { key: "Unit Name/Number", value: "24" },
//     ],
//   },
//   {
//     pair: [
//       { key: "Available Unit", value: "33" },
//       { key: "Total Unit", value: "43" },
//     ],
//   },
//   {
//     pair: [
//       { key: "Total Views", value: "121" },
//       { key: "Bookmarks", value: "21" },
//     ],
//   },
//   {
//     pair: [
//       { key: "Added Date", value: "21/01/2025" },
//       { key: "Last Updated", value: "21/01/2025" },
//     ],
//   },
// ];
const propertyDetails: PropertyData[] = [
  { key: "Property Title", value: "Obolongo Estate" },
  { key: "Discount Name", value: "Ileya Festival Promo" },
  { key: "Unit Preference", value: "Newly Built" },
  { key: "Discount Rate", value: "30%" },
  { key: "Document", value: "C of O. Record Copy Survey, Agreement" },
  {
    pair: [
      { key: "Unit Type", value: "21" },
      { key: "Discount Rate", value: "30%" },
    ],
  },
  {
    pair: [
      { key: "Bedroom", value: "21" },
      { key: "Bathroom", value: "21" },
    ],
  },
  {
    pair: [
      { key: "Unit Name/Number", value: "21" },
      { key: "Available Unit", value: "43" },
    ],
  },
  {
    pair: [
      { key: "Total Unit", value: "21" },
      { key: "Total Area", value: "4354sqm" },
    ],
  },
  {
    pair: [
      { key: "Total Views", value: "121" },
      { key: "Bookmarks", value: "21" },
    ],
  },
  {
    pair: [
      { key: "Added Date", value: "21/01/2025" },
      { key: "Last Updated", value: "21/01/2025" },
    ],
  },
];
export const planImage = [
  "/images/plan-image-1.webp",
  "/images/plan-image-2.webp",
  "/images/plan-image-3.webp",
  "/images/plan-image-4.webp",
  "/images/plan-image-5.webp",
  "/images/plan-image-6.webp",
  "/images/plan-image-7.webp",
  "/images/plan-image-8.webp",
  // "/images/plan-image-1.webp",
  // "/images/plan-image-1.webp",
  // "/images/plan-image-1.webp",
];

const propertyDetailsAlt: PropertyData[] = [
  { key: "Property Title", value: "Obolongo Estate" },
  { key: "Category", value: "Residential" },
  {
    key: "Unit",
    value: "Unit 3 Bedroom, 1 Unit Self Contained With Penthouse",
  },
  { key: "Document", value: "C of O. Record Copy Survey, Agreement" },
  { key: "Source/Owner", value: "Ibrahim Matthew" },
  {
    pair: [
      { key: "Total Area", value: "4354sqm" },
      { key: "Offer", value: "21" },
    ],
  },
  {
    pair: [
      { key: "Total Views", value: "121" },
      { key: "Bookmark", value: "21" },
    ],
  },
  {
    pair: [
      { key: "Last Updated", value: "21/01/2025" },
      { key: "Added Date", value: "21/01/2025" },
    ],
  },
];
